import { useDrag, ConnectDragSource } from 'react-dnd';

const useDragElement: Function = (elementType: string, itemId: string, index: number): DragOptions => {
  const [{ isDragging }, drag]: [DragProps, ConnectDragSource, DragMonitor] = useDrag({
    type: elementType,
    item: {
      type: elementType,
      id: itemId,
      index,
    },
    collect: (monitor: DragMonitor): DragProps => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    isDragging,
    dragRef: drag,
  };
};

export default useDragElement;
